import { DevicesAPI, IGetDeviceByNameParams } from "../../services/hcnApi";

export const clearDeviceCacheUseCase = async (params: IGetDeviceByNameParams) => {
  await DevicesAPI.clearDeviceCache(params);
};
